import React, { MouseEventHandler, ReactChild } from 'react';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Tooltip from '@mui/material/Tooltip';

import { classNames } from './utils';

import styles from './ToggleGroup.module.css';

function ToggleButton({
  children,
  value,
  isCurrent,
  handleClick,
  tooltip,
}: {
  children?: ReactChild;
  value: string;
  isCurrent: boolean;
  handleClick: MouseEventHandler<HTMLButtonElement>;
  tooltip?: string;
}) {
  const internal = (
    <Button
      data-selected={isCurrent}
      size="small"
      onClick={isCurrent ? null : handleClick}
      value={value}
      key={value}
      variant={isCurrent ? 'contained' : undefined}
      className={styles.switch_button}
    >
      {children}
    </Button>
  );
  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="left">
        {internal}
      </Tooltip>
    );
  }
  return internal;
}

export function ToggleGroup({
  handleClick,
  value,
  values,
  labelMap,
  tooltips,
  horizontal = false,
  className = '',
}: {
  handleClick: MouseEventHandler<HTMLButtonElement>;
  value: string;
  values: readonly string[];
  labelMap?: { [index: string]: string };
  tooltips?: { [index: string]: string };
  horizontal?: boolean;
  className?: string;
}) {
  return (
    <ButtonGroup
      fullWidth
      disableElevation
      orientation={horizontal ? 'horizontal' : 'vertical'}
      aria-label="outlined secondary button group"
      className={classNames(styles.switch_container, className)}
    >
      {values.map((item_value) => {
        return (
          <ToggleButton
            value={item_value}
            isCurrent={item_value === value}
            handleClick={handleClick}
            tooltip={tooltips && tooltips[item_value]}
            key={item_value}
          >
            {labelMap?.[item_value] ?? item_value}
          </ToggleButton>
        );
      })}
    </ButtonGroup>
  );
}
